import { useGetAllTariffsQuery } from 'Services/ProductManagement/Features/Tariff/tariffApi'
import { All_TARIFFS_COUNT_PER_REQUEST } from 'Util/constants'

function useAllTariffs() {
  const { data, isLoading } = useGetAllTariffsQuery({
    bypass_pagination: true,
    count: All_TARIFFS_COUNT_PER_REQUEST
  })

  return {
    allTariffs: data?.resources || [],
    isAllTariffsLoading: isLoading,
    totalResults: data?.total_results || 0
  }
}

export default useAllTariffs
